import api from './axios';

export const getCourses = (params) => api.get('/courses', { params });
export const getCourse = (id) => api.get(`/courses/${id}`);
export const createCourse = (data) => api.post('/courses', data);
export const updateCourse = (id, data) => api.put(`/courses/${id}`, data);
export const deleteCourse = (id) => api.delete(`/courses/${id}`);
export const getCourseTopics = (courseId) => api.get(`/courses/${courseId}/topics`);
export const createCourseTopic = (courseId, data) => api.post(`/courses/${courseId}/topics`, data);
export const updateCourseTopic = (courseId, topicId, data) => api.put(`/courses/${courseId}/topics/${topicId}`, data);
export const deleteCourseTopic = (courseId, topicId) => api.delete(`/courses/${courseId}/topics/${topicId}`);